import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, FormControlLabel, Switch } from '@mui/material';

const SwitchV2 = ({ checked, handleChange, label }) => {
  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Switch
            checked={checked}
            onChange={handleChange}
            name="checkedA"
            color="primary"
          />
        }
        label={label}
        sx={{
          '& .MuiFormControlLabel-label': {
            color: 'primary.main',
          },
        }}
      />
    </FormGroup>
  );
};

SwitchV2.propTypes = {
  checked: PropTypes.bool,
  handleChange: PropTypes.func,
  label: PropTypes.string,
};

SwitchV2.defaultProps = {
  checked: false,
  handleChange: () => {},
  label: '',
};

export default SwitchV2;
